/**
 * We add another layer to access GTM for easier calls even when GTM is not defined.
 * @param context
 * @param inject
 */
export default (context, inject) => {
    inject('analytics', {
        init: function (gtmId) {
            if (context.$gtm) {
                context.$gtm.init(gtmId)
            }
        },

        track: function (object) {
            if (context.$gtm) {
                context.$gtm.push(object)
            }
        },

        trackEcommerceEvent: function (event, ecommerceData) {
            // We need to clear the data for the next event / page view
            this.track({ecommerce: null})
            this.track({
                event: event,
                ecommerce: ecommerceData
            });
        }
    })
}